import { AppBar, Typography, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';


const styles = {
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
};

function Topbar({ className, ...rest }) {
  return (
    <AppBar
      {...rest}
      className={className}
      sx={styles.root}
      color="secondary"
    >
      <Toolbar>
        {/* <img
            alt="Logo"
            src={logo}
          /> */}
        <Typography
          variant="h4"
          component="h3"
          style={{ fontFamily: 'AssistantRegular',color:'#FF9800'}}
        >
          apollo
          </Typography>

      </Toolbar>
    </AppBar>
  );
}

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
